import { api } from "../api";

/**
 * findAllVehicleColorsListResponse - Function that finds on database all vehicles colors as select list response   
 * /vehicles/colors  
 * method GET 
 * @async-function
 */
const findAllVehicleColorsListResponse = async (token: string) => {
    const response = await api.get(
        `/vehicles/colors`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
         }
    );
    return response;
};

export default findAllVehicleColorsListResponse;